import { render, staticRenderFns } from "./CommissionStatistics.vue?vue&type=template&id=018c266c"
import script from "./CommissionStatistics.vue?vue&type=script&lang=js"
export * from "./CommissionStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports